<script setup lang="ts">
import backdropUrl from "./backdrop.png"
</script>

<template>
    <div class="container">
        <div class="breadcrumb">
            <RouterLink class="breadcrumb-item" :to="{ name: 'home' }">Home</RouterLink>
            <div class="breadcrumb-item">Kontakt</div>
        </div>

        <div class="teaser mb-5">
            <div class="teaser-text">
                <h1>Kontakt</h1>

                <p class="mt-4">
                    apotheke am inselpark
                    <br />
                    Neuenfelder Straße 31
                    <br />
                    21109 Hamburg
                    <br />
                    040.30 23 86 99 24
                    <br />
                    info@cann24.de
                </p>

                <p>
                    Inhaber: Apotheker Björn Schrage e.K.
                    <br />
                    Verantwortlich für den Inhalt nach § 55 RStV
                    <br />
                    und § 5 TMG: Apotheker Björn Schrage e.K.
                    <br />
                    apotheke am inselpark
                </p>

                <div class="mt-5">
                    <!--                    <img src="./facebook.png" alt="" class="mr-4">-->
                    <a href="https://instagram.com/cann24.official" target="_blank">
                        <img src="./instagram.png" class="mr-4" alt="instagram icon" />
                    </a>
                    <!--                    <img src="./youtube.png" alt="">-->
                </div>
                <div class="mt-4">
                    Hast du Fragen? Dann schau auch gerne mal in unseren
                    <RouterLink :to="{ name: 'faq' }">Häufig gestellten Fragen</RouterLink>
                    (FAQs) vorbei. Hier findest du weitere Informationen.
                </div>
            </div>
            <div class="teaser-image">
                <img src="./contact01.jpg" class="img-fluid" alt="" />
            </div>
        </div>
    </div>

    <div class="contact-backdrop footer-flush-element" :style="{ backgroundImage: `url(${backdropUrl})` }"></div>
</template>

<style scoped>
.contact-backdrop {
    background: #f8f8f9 no-repeat center;
    background-size: cover;
    height: 629px;
}
</style>
